import callApi, { enrichedCallApi } from "@repo/next-shared/utils/api";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { Consumer } from "@/types/consumer";
import { transformNullToEmpty } from "@repo/next-shared/utils";

export async function getCustomer() {
  return await callApi({ path: "/consumer/", method: "GET" });
}

export async function updateCustomer(payload: any) {
  return await callApi({ path: "/consumer/", method: "PUT", payload });
}

export async function updateUser(payload: any) {
  return await callApi({ path: "/consumer/user", method: "PUT", payload });
}

export async function deleteCustomer() {
  return await enrichedCallApi({ path: "/consumer/", method: "DELETE" });
}

export async function returnProduct(payload: any) {
  return await callApi({ path: "/consumer/return", method: "POST", payload });
}

export function useCustomer() {
  return useQuery({
    queryKey: ["customer"],
    queryFn: getCustomer,
    select: (data: Consumer) => transformNullToEmpty(data),
  });
}

export function useSuspenseCustomer() {
  return useSuspenseQuery({
    queryKey: ["customer"],
    queryFn: getCustomer,
    select: (data: Consumer) => transformNullToEmpty(data),
  });
}
